<div class="inputs">
    <date-input class="input" [initialPlaceHolder]="'Desde'" [isIncomplete]="isIncompleteInit"
    [value]="valueInit" [maxDate]="valueEnd" (valueOut)="emitValues($event, 'init')" 
    [isFilter]="isFilter" [arrayDatesFilter]="arrayDatesFilter"></date-input>

    <date-input class="input" [initialPlaceHolder]="'Hasta'" [isIncomplete]="isIncompleteEnd"
    [value]="valueEnd" [minDate]="valueInit" (valueOut)="emitValues($event, 'end')"
    [isFilter]="isFilter" [arrayDatesFilter]="arrayDatesFilter"></date-input>
</div>